/*
 * @Author: your name
 * @Date: 2022-01-04 17:09:31
 * @LastEditTime: 2022-03-10 14:11:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

// const routerReplace = Router.prototype.replace
// Router.prototype.replace = function replace(location) {
//   return routerReplace.call(this, location).catch(error=> error)
// }
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
